import { render, staticRenderFns } from "./TaxInvoiceComponentProvider.vue?vue&type=template&id=112bb330&scoped=true&"
import script from "./TaxInvoiceComponentProvider.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceComponentProvider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=112bb330&scoped=true&lang=css&"
import style1 from "./TaxInvoiceComponentProvider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112bb330",
  null
  
)

export default component.exports